import { Badge } from '@/components/ui/badge';
import { Sparkles, ArrowUpCircle, ArrowDownCircle } from 'lucide-react';

const fmtCurrency = (amt) => {
  if (amt == null) return '$0';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.abs(amt));
};

const fmtDate = (d) => {
  if (!d) return '';
  const [y, m, day] = d.split('-').map(Number);
  return `${m}/${day}/${y}`;
};

const catLabel = (s) => {
  const parts = [s.category, s.subcategory, s.detail].filter(Boolean);
  return parts.join(' > ') || 'No category';
};

export function TransactionReviewCard({ current }) {
  const { txn } = current;
  return (
    <div className="p-4 rounded-lg border border-border/60 bg-[#faf8f4]" data-testid="ai-review-txn-card">
      <div className="flex items-start justify-between gap-3 mb-2">
        <div className="flex-1 min-w-0">
          {txn.title && (
            <p className="font-semibold text-sm text-[#1f2933] mb-0.5">{txn.title}</p>
          )}
          <p className={`text-xs ${txn.title ? 'text-muted-foreground' : 'text-[#1f2933]'} break-words`}>
            {txn.description}
          </p>
          <div className="flex gap-3 mt-1.5 text-[11px] text-muted-foreground">
            <span>{fmtDate(txn.date)}</span>
            {txn.bank && <span>{txn.bank}</span>}
            {txn.source && <span>{txn.source}</span>}
          </div>
        </div>
        <span className={`text-sm font-semibold tabular-nums flex items-center gap-1 flex-shrink-0 ${txn.type === 'income' ? 'text-emerald-700' : 'text-red-700'}`}>
          {txn.type === 'income' ? <ArrowUpCircle className="h-3.5 w-3.5" /> : <ArrowDownCircle className="h-3.5 w-3.5" />}
          {txn.type === 'income' ? '+' : '-'}{fmtCurrency(txn.amount)}
        </span>
      </div>

      <div className="mt-2 pt-2 border-t border-border/30">
        <p className="text-[10px] font-semibold uppercase tracking-wide text-muted-foreground mb-1">AI Suggestion</p>
        {current.loading ? (
          <span className="inline-flex items-center gap-1 text-[11px] text-muted-foreground" data-testid="ai-suggestion-loading">
            <Sparkles className="h-3 w-3 animate-pulse text-primary" />
            Loading suggestion…
          </span>
        ) : current.error ? (
          <span className="text-[11px] text-red-600" data-testid="ai-suggestion-error">
            Failed to load (pick manually below)
          </span>
        ) : (
          <Badge variant="secondary" className="text-xs" data-testid="ai-suggestion-label">
            {catLabel(current)}
          </Badge>
        )}
      </div>
    </div>
  );
}
